import styles from './index.module.css'

import React from 'react'
import { Link } from 'react-router-dom'

import { DiscoCallout, Flex, Text } from 'components/ds'

const NewSearchPageBanner = () => {
  return (
    <DiscoCallout
      type="feature"
      size="1"
      mt="2"
      dismissible
      dismissKey="new_search_page_banner_dismissed"
    >
      <Flex mr="1">
        <Text wrap="balance" className={styles.bannerText}>
          We have improved DISCO Search. Better filtering and more metadata at a
          glance.{' '}
          <Link to="/search" className={styles.bannerLink}>
            Access it here.
          </Link>
        </Text>
      </Flex>
    </DiscoCallout>
  )
}

export default NewSearchPageBanner
